/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useRef, useState} from 'react'
import { Button, ProgressBarAnimated } from '@intelie/ui'

import i18n from 'live/services/i18n'

import globalNotification from 'live/services/global-notification'
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'

import { Template } from '../../types'
import { EditorHeader } from './components/EditorHeader'
import { createTemplate, getTemplate, updateTemplate } from '../../services/template'
import { ANNOTATIONS_TEMPLATES_URL } from '../../constants'
import { FormRenderer } from '../../formBuilder/components/FormRenderer'
import { FormBuilderModal } from '../../formBuilder/components/FormBuilderModal'
import { EditorContainer, PreviewContainer } from '../styles'
import FormBuilder from "../../formBuilder/components/builder"

interface TemplateEditProps {
    urlParams?: string[]
    readonly?: boolean
}

const TemplateEditor: FC<TemplateEditProps> = ({ urlParams }: TemplateEditProps) => {
    const [loading, setLoading] = useState<boolean>(true)
    const [template, setTemplate] = useState<Template>({
        alias: '',
        color: '#000000',
        perspective: null,
        description: '',
        schema: '{"elements": []}',
        active: false
    })
    const [schema, setSchema] = useState<FormSchema>({ elements: [] })

    const formRef = useRef()

    useEffect(() => {
        const fetchTemplate = async (id: string): Promise<void> => {
            try {
                const templateData = await getTemplate(id)

                setTemplate(templateData)
                setSchema(JSON.parse(templateData.schema) as FormSchema)
            } catch (error) {
                globalNotification.error(i18n(error.message), 5)
            }
        }

        if (urlParams?.[1] && urlParams?.[1] !== 'new') {
            fetchTemplate(urlParams?.[1])
        }

        setLoading(false)
    }, [])

    const onSubmit = async (): Promise<void> => {
        try {
            JSON.parse(template.schema)

            if (urlParams?.[1] && urlParams?.[1] !== 'new') {
                await saveUpdateTemplate()
            } else {
                await saveNewTemplate()
            }

            globalNotification.success(i18n('Template saved successfully'), 5)

            goBack()
        } catch (error) {
            globalNotification.error(i18n(error.message))
        }
    }

    const saveNewTemplate = async (): Promise<void> => {
        await createTemplate({
            active: template.active,
            alias: template.alias,
            color: template.color,
            schema: JSON.stringify(formRef.current),
            description: template.description,
            perspective: template.perspective
        })
    }

    const saveUpdateTemplate = async (): Promise<void> => {
        await updateTemplate({...template, schema: JSON.stringify(formRef.current)})
    }

    const goBack = (): void => {
        window.location.href = ANNOTATIONS_TEMPLATES_URL
    }

    return (
        <>
            {loading ? (
                <ProgressBarAnimated />
            ) : (
                <>
                    <EditorHeader template={template} isNew={urlParams[1] === 'new'} setTemplate={setTemplate} />
                    <EditorContainer>
                        <FormBuilder
                            formRef={formRef}
                            schema={schema}
                        />
                        <div className="form-footer full">
                            <SubmitOrCancel
                                saved={false}
                                saving={false}
                                disabled={false}
                                btnsClassName="btn-lg btn-bold"
                                cancelHref={ANNOTATIONS_TEMPLATES_URL}
                                onCancel={goBack}
                                onSubmit={onSubmit}
                            />
                        </div>
                    </EditorContainer>
                </>
            )}
        </>
    )
}

export default TemplateEditor
